import { CheckCheck, Undo2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { ConferenceAction } from './useInboxConference'

interface InboxBulkBarProps {
  action: ConferenceAction
  total: number
  selected: number
  busy: boolean
  onToggleAll: () => void
  onRun: () => void
}

/** Barra acima da lista: selecionar a página toda e conferir (ou desfazer) as marcadas. */
export function InboxBulkBar({ action, total, selected, busy, onToggleAll, onRun }: InboxBulkBarProps) {
  if (total === 0) return null
  const all = selected === total
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 px-3">
      <label className="flex cursor-pointer items-center gap-2 text-sm text-muted-foreground">
        <input
          type="checkbox"
          className="size-4 accent-primary"
          checked={all}
          ref={(el) => {
            if (el) el.indeterminate = selected > 0 && !all
          }}
          onChange={onToggleAll}
          aria-label="Selecionar todas da página"
        />
        {selected > 0 ? `${selected} selecionada(s)` : 'Selecionar todas'}
      </label>
      {selected > 0 && (
        <Button size="sm" variant={action === 'conferir' ? 'default' : 'outline'} disabled={busy} onClick={onRun}>
          {action === 'conferir'
            ? <><CheckCheck aria-hidden="true" /> Marcar como conferidas</>
            : <><Undo2 aria-hidden="true" /> Desfazer conferência</>}
        </Button>
      )}
    </div>
  )
}
